module.exports = __webpack_public_path__ + "officialStatic/img/product-crm.78cdd1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/product-crm.png
// module id = uqxK
// module chunks = 0